// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__kJTQb","hero__title":"styles_hero__title__SSb6x"};